import * as yup from "yup";
import type { ItemListId } from "../../tracking/create-ecommerce-event";

export type CartProduct = yup.InferType<typeof cartProductSchema> & {
  item_list_id?: ItemListId;
  index?: number;
};

export const cartProductSchema = yup.object({
  uuid: yup.string().required(),
  name: yup.string().required(),
  quantity: yup.number().required().default(1),
  grossPrice: yup.string().required(),
  isUpsell: yup.boolean().required(),
  upsellBloodTestPackageUuids: yup.array().of(yup.string().required()).required(),
  bloodTests: yup
    .array()
    .of(yup.object({ name: yup.string().required() }))
    .required()
    .default([]),
});
